import React, { useEffect, useState } from 'react';
import { Message, Calendar } from '@alifd/next';

import moment from 'moment';
import 'antd/dist/antd.css';
import { Modal, Tabs, Table } from 'antd'; // dialog UI

import axios from 'axios';
import styles from './index.module.scss';

const currentDate = moment();
const localeData = currentDate.clone().localeData();
const monthLocale = localeData.monthsShort();
const AnnualSchedule = ({ backStageUpdateTrigger }) => {
  const [yearSelect] = useState([]); // Calendar年 選擇
  const [cleanArr, setCleanArr] = useState([]); // Calendar render filtered Data(渲染資料)
  const [cleanCurrentArr, setCleanCurrentArr] = useState([]);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [showDate, setShowDate] = useState(moment().add(0, 'days'));
  const [tab, setTab] = useState(2);

  useEffect(() => {
    axios('/ezcon/api/annualPlan', {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    })
      .then((res) => {
        setCleanArr(res.data);
      })
      .catch((err) => {
        Message.error(err);
      });
  }, [backStageUpdateTrigger]);

  function monthCellRender2(date) {
    // render年
    const thisStartDate = new Date(
      `${date.year()}/${date.month() + 1}/1`
    ).getTime(); // 月初time
    const thisEndDate = new Date(date.year(), date.month() + 1, 0).getTime(); // 月底time
    const renderArr = [];
    const idArrs = [];
    const eventList = cleanArr.filter(
      (i) => i.cleanTime >= thisStartDate && i.cleanTime <= thisEndDate
    ); // 找到當月所有任務(有重複)
    eventList.forEach((e) => {
      // 過濾掉相同id任務(只show一次)
      if (!idArrs.includes(e.category)) {
        idArrs.push(e.category);
        renderArr.push(e);
      }
    });
    const formatStr = renderArr.map((i, nb) => {
      return (
        <div
          key={nb}
          className={
            (i.isYear === 1 && styles.dayStyle1) ||
            (i.isYear === 2 && styles.dayStyle2) ||
            (i.isYear === 3 && styles.dayStyle3) ||
            (i.isYear === 4 && styles.dayStyle4)
          }
          style={
            i.isYear === 1
              ? { backgroundColor: i?.color }
              : { backgroundColor: '#2828ff' }
          }
        >
          {i.name}
        </div>
      );
    });

    return (
      <>
        <div>{monthLocale[date.month()]}</div>
        <div className={styles.calendarYearBox}>
          <div>{formatStr}</div>
        </div>
      </>
    );
  }

  function dateCellRender2(date) {
    // 渲染測試
    const dateNum = date.date();
    const thisCalendarDate = moment(
      new Date(`${date.year()}/${date.month() + 1}/${dateNum}`)
    ).format('YYYY/MM/DD'); // 當日time

    const eventList = cleanArr.filter(
      (i) => moment(i.cleanTime).format('YYYY/MM/DD') === thisCalendarDate
    );
    const formatStr = eventList.map((i, nb) => {
      return (
        <div key={nb}>
          <div
            className={
              (i.isYear === 1 && styles.dayStyle1) ||
              (i.isYear === 2 && styles.dayStyle2) ||
              (i.isYear === 3 && styles.dayStyle3) ||
              (i.isYear === 4 && styles.dayStyle4)
            }
            style={
              i.isYear === 1
                ? { backgroundColor: i?.color }
                : { backgroundColor: '#2828ff' }
            }
          >
            {i.name}
          </div>
          {/* <div>注意事項:{i.contentText}</div> */}
        </div>
      );
    });
    return (
      <>
        <div className={styles.calendarMonthBox}>
          <div className={styles.calendarMonthText}>{dateNum}</div>
          <div>{formatStr}</div>
        </div>
      </>
    );
  }
  const columns = [
    {
      title: '計畫表日期',
      dataIndex: 'cleanTime',
      render: (text) => moment(text).format('YYYY/MM/DD'),
    },
    {
      title: '計畫表項目',
      dataIndex: 'name',
    },
    {
      title: '計畫表類型',
      dataIndex: 'isYear',
      render: (text) => (text === 1 ? '長期修繕計畫' : '年度維護計畫'),
    },
    {
      title: '計畫表類別',
      dataIndex: 'category',
    },
  ];
  return (
    <>
      <Modal
        cancelText
        mask={false}
        className={styles.dialog}
        visible={previewDialog}
        onOk={() => {
          setPreviewDialog(false);
        }}
        onCancel={() => {
          setPreviewDialog(false);
        }}
        okText="關閉"
      >
        <h1>計畫表項目</h1>
        <Tabs
          defaultActiveKey="2"
          onChange={(value) => setTab(parseInt(value, 10))}
        >
          <Tabs.TabPane tab="年度維護計畫" key="2" />
          <Tabs.TabPane tab="長期修繕計畫" key="1" />
        </Tabs>
        <Table
          columns={columns}
          dataSource={cleanCurrentArr.filter((item) => item.isYear === tab)}
        />
      </Modal>
      {/* 日曆ＵＩ */}
      <Calendar
        // mode
        onSelect={(value) => {
          const tarDialogDate = moment(value).format('YYYY/MM/DD');

          const filterRenderData = [...cleanArr].filter(
            (e) => moment(e.cleanTime).format('YYYY/MM/DD') === tarDialogDate
          );
          if (filterRenderData.length > 0) {
            setShowDate(moment(new Date(value).getTime()).add(0, 'days'));
            setCleanCurrentArr([...filterRenderData]);
            setPreviewDialog(true);
            Message.success('找尋資料成功');
          } else {
            Message.success('該天沒有資料!');
          }
        }}
        dateCellRender={dateCellRender2}
        monthCellRender={monthCellRender2}
        yearRange={yearSelect}
        value={showDate}
      />
    </>
  );
};

export default AnnualSchedule;
